<template>
  <span id="add-storage-Position" v-if="showAddStoragePositions()">
    <el-button
      id="add-storage-position-button"
      class="button-action-default add-storage-Position-margin-bottom"
      size="mini"
      type="success"
      plain
      @click="dialogVisible = true"
    >{{ $t('layoutTemplate.addPosition') }}</el-button>

    <el-dialog
      id="add-storage-Position-dialog"
      v-on:open="handleOpen"
      :title="$t('layoutTemplate.addPosition')"
      :visible.sync="dialogVisible"
      width="60%"
      class="dialog-with-cols"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row :gutter="30">
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.viewDetailsTitle')" prop="warehouse">
              <el-input class="inline-input" :value="layoutTemplateName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.storageLocation')" prop="storageLocationId">
              <el-input
                class="inline-input"
                :value="storageLocationCode.concat($t(areaCode))"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.position')" prop="positionNumber">
              <el-input
                class="inline-input"
                v-model="form.positionNumber"
                maxlength="50"
                clearable
                v-alphanumeric-validation
                :placeholder="$t('layoutTemplate.placeHolders.positionNumber')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.consignee')" prop="accountId">
              <autocomplete :model.sync="form.accountId"
                :shipperAccountId="null"
                labelFieldLastWithDash="number"
                popperAppendToBody
                :url="urlConsignee"
                labelField="name"
                valueField="id"
                id="rows-consignee"
                ref="rows-consignee" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        id="add-storage-Position-dialog-footer"
        slot="footer"
        class="dialog-footer form-vertical-item flex-reverse-direction"
      >
        <el-button
          type="primary"
          id="save-storage-Position-button"
          @click="submitForm()"
          size="mini"
        >{{ $t('layoutTemplate.addPosition') }}</el-button>
        <el-button
          id="refresh-storage-Position-button"
          @click="resetForm()"
          size="mini"
        >{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  components: { Autocomplete },
  name: 'AddStoragePosition',
  props: {
    layoutTemplateId: {
      type: Number,
      required: true
    },
    storageLocationId: {
      type: Number,
      required: true
    },
    layoutType: {
      type: Number,
      required: true
    },
    layoutTemplateName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['storageLocation']),
    storageLocationCode() {
      const storageLocation = this.storageLocation.list.find(
        location => location.id === this.storageLocationId
      );

      if (storageLocation) {
        return storageLocation.code.concat(' - ');
      }
      return 'ERROR';
    },
    areaCode() {
      const storageLocation = this.storageLocation.list.find(
        location => location.id === this.storageLocationId
      );
      if (storageLocation) {
        const selectedArea = constants.LAYOUT_TEMPLATE.AREA_OPTIONS.find(
          area => area.value === storageLocation.area
        );

        if (selectedArea) {
          return selectedArea.label;
        }
      }
      return 'layoutTemplate.error.areaInvalid';
    }
  },
  data() {
    return {
      urlConsignee: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
      dialogVisible: false,
      form: {
        storageLocationId: 0,
        positionNumber: null,
        accountId: null
      },
      formRules: {
        positionNumber: [
          {
            required: true,
            message: this.$t(
              'layoutTemplate.error.positionRequired'
            ),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    async submitForm() {
      Object.assign(this.form, { storageLocationId: this.storageLocationId });
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.$store
              .dispatch('storagePosition/save', this.form)
              .then((response) => {
                loading.close();
                this.$message.success(response.message);
                this.resetForm();
                this.$emit('searchStoragePositions');
                this.$store.dispatch('storageLocation/search', {});
                resolve(response);
              })
              .catch((error) => {
                loading.close();
                resolve(error);
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.positionNumber = null;
      this.clearAutocomplete();
    },
    clearAutocomplete() {
      this.accountId = null;
      this.$refs['rows-consignee'].clearLocalModel();
    },
    showAddStoragePositions() {
      return (this.layoutType === constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.TEMPLATE && this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUT_TEMPLATES))
          || (this.layoutType === constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.LAYOUT && this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUTS));
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.add-storage-Position-margin-bottom {
  margin-bottom: 10px;
}
</style>
